/**
 * Header Component
 */
export class Header {
    constructor() {
        this.header = document.getElementById("main-header");
        this.drawer = document.getElementById("main-drawer");
        this.languageBtn = document.getElementById("language-btn");

        if (!this.header) return;

        this.init();
    }

    init() {
        this.initNav();
        this.initDrawer();
        this.initLanguageButton();
    }

    initLanguageButton() {
        if (!this.languageBtn) return;

        // 약간의 지연을 두어 LanguageModal이 먼저 초기화되도록 함
        setTimeout(() => {
            this.languageBtn.addEventListener("click", (e) => {
                e.preventDefault();

                // LanguageModal 인스턴스 확인
                if (window.languageModalInstance) {
                    window.languageModalInstance.open();
                    this.languageBtn.setAttribute("aria-expanded", "true");
                } else {
                    console.warn("Header: LanguageModal instance not found");
                }
            });
        }, 100);
    }

    initNav() {
        const nav = this.header.querySelector(".no-header__nav");
        if (!nav) return;

        const root = document.documentElement;
        const syncHeaderHeightVar = () => {
            const h = this.header.offsetHeight;
            // root.style.setProperty("--header-height", h + "px");
        };
        const clearHeaderHeightVar = () => {
            // root.style.removeProperty("--header-height");
        };

        if (typeof gsap !== "undefined") {
            const tl = gsap.timeline({ paused: true });

            tl.to(this.header, {
                height: () => nav.offsetHeight + "px",
                ease: "power3.inOut",
                onUpdate: syncHeaderHeightVar,
            });

            const onEnter = () => {
                this.header.setAttribute("aria-expanded", "true");
                tl.play();
            };

            const onLeave = () => {
                this.header.removeAttribute("aria-expanded");
                tl.reverse();
                tl.eventCallback("onReverseComplete", clearHeaderHeightVar);
            };

            nav.addEventListener("mouseenter", onEnter);
            this.header.addEventListener("mouseleave", onLeave);

            window.addEventListener("resize", () => {
                if (window.innerWidth <= 1024) {
                    this.header.removeAttribute("style");
                    this.header.removeAttribute("aria-expanded");
                    clearHeaderHeightVar();
                } else if (
                    this.header.getAttribute("aria-expanded") === "true"
                ) {
                    syncHeaderHeightVar();
                }
            });
        }
    }

    initDrawer() {
        if (!this.drawer) return;

        const drawerOpenBtn = this.header.querySelector(".no-header__toggle");
        const drawerCloseBtn = this.drawer.querySelector(
            ".no-drawer__close, #drawer-close-btn",
        );

        if (typeof gsap !== "undefined") {
            // 초기 상태 설정 (깜빡임 방지)
            gsap.set(this.drawer, {
                y: "-100%",
                opacity: 0,
            });
            this.drawer.style.visibility = "hidden";
            this.drawer.style.pointerEvents = "none";

            const drawerTl = gsap.timeline({ paused: true });
            drawerTl.to(this.drawer, {
                y: "0%",
                opacity: 1,
                duration: 0.5,
                ease: "power3.out",
            });

            const onOpen = () => {
                document.body.classList.add("--hidden");
                document.body.style.overflow = "hidden";
                this.drawer.style.visibility = "visible";
                this.drawer.style.pointerEvents = "auto";
                this.drawer.classList.add("is-open");
                drawerTl.play();
            };

            const onClose = () => {
                document.body.classList.remove("--hidden");
                document.body.style.overflow = "";
                this.drawer.classList.remove("is-open");
                drawerTl.reverse();

                // 애니메이션 완료 후 숨김 처리
                drawerTl.eventCallback("onReverseComplete", () => {
                    this.drawer.style.visibility = "hidden";
                    this.drawer.style.pointerEvents = "none";
                });

                if (window.drawerInstance) {
                    window.drawerInstance.closeAllSubmenus();
                }
            };

            if (drawerOpenBtn) {
                drawerOpenBtn.addEventListener("click", onOpen);
            }

            if (drawerCloseBtn) {
                drawerCloseBtn.addEventListener("click", onClose);
            }

            document.addEventListener("keydown", (e) => {
                if (
                    e.key === "Escape" &&
                    this.drawer.classList.contains("is-open")
                ) {
                    onClose();
                }
            });
        }
    }
}
